<div class="modal-content" style="width: 120%;height: 112%">
<div class="modal-header">
  <button type="button" class="close" aria-label="Close" (click)="closeBSF()">
    <span aria-hidden="true">&times;</span>
  </button>
  <h4 class="modal-title" translate>CONTRACT_CLOSE_SITE_BILLING_MODAL_TITLE
    <span *ngIf="selectedItem?.length" translate>({{selectedItem?.length}} selected subscriptions)</span></h4>
</div>
<div class="modal-body" >
  <div class="portlet-body modal-body-min-h">
    <div class="help-block errorTitle" *ngIf="billedUpMsg" ><span translate>END_BILLINGS_START_DATE_BLOCKED</span>({{billedUpMsg| date: 'dd/MM/yyyy'}})</div>
    <div class="help-block errorTitle" *ngIf="endUpMsg !== 'false' && endUpCloseMsg === 'false'" ><span>{{endUpMsg}}</span></div>
    <div class="help-block errorMessage" *ngIf="endUpCloseMsg !== 'false'" >{{endUpCloseMsg}}</div>
    <span *ngIf="selectedOneItem ; else multiItems">
          <storever-header-subtitle [datas]="[
           {icon: 'fa-map-marker-alt', title: 'GENERIC_SITE', name: selectedOneItem?.name},
           {icon: 'fal fa-box', title: 'GENERIC_PRODUCT', name: selectedOneItem?.productName},
           {icon: selectedOneItem?.billedUp ? 'fas fa-lock' : 'fad fa-calendar-day',
            title: selectedOneItem?.billedUp ? 'END_BILLING_START_DATE_BLOCKED' : 'END_BILLING_START_DATE',
             name: selectedOneItem?.start| date: 'dd/MM/yyyy' }    ]"></storever-header-subtitle>
      </span>
    <ng-template #multiItems >
      <div [ngClass]="selectedItem?.length > 6 ? 'scroll' : null" class="ban">
          <span *ngFor="let item of selectedItem let i = index " >
          <storever-header-subtitle   [isAllowedRemove]="true" [datas]="[
           {icon: 'fa-map-marker-alt', title: 'GENERIC_SITE', name: item?.name},
           {icon: 'fal fa-box', title: 'GENERIC_PRODUCT', name: item?.productName},
           {icon: item?.billedUp ? 'fas fa-lock' : 'fad fa-calendar-day',
           title: item?.billedUp ? 'END_BILLING_START_DATE_BLOCKED' : 'END_BILLING_START_DATE', name: item?.start | date: 'dd/MM/yyyy' },
           {icon: checkEndDateStatus(item) ? 'fad fa-ban' : 'fad fa-calendar-day',
           title:  checkEndDateStatus(item) ?  'ORDER_NOT_ALLOWED_TEXT' : 'END_BILLING_END_DATE', name: item?.end | date: 'dd/MM/yyyy' }]">
            <i class="fal fa-trash-alt" *ngIf="selectedItem?.length > 1" style="margin-top:6px" tooltip="{{ 'DELETE' | translate:locale.language}}" (click)="removeItem(i)"></i>
            </storever-header-subtitle>
      </span>
        </div>
    </ng-template >
    <form [formGroup]="myForm" >
      <div class="textInput textArea">
        <storever-element-group
          [icon]="'fa-address-book'"
          [title]="'none'"
          [config]="formConfig.config"
          [form]="myForm">
        </storever-element-group>
      </div>
    </form>
    <br>
    <div class="help-block error error-msg-padding" *ngIf="error !== 'false'">{{error}}</div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" [disabled]="myForm.invalid || error !== 'false' || endUpCloseMsg!== 'false'"
          (click)="send(myForm.value)"> {{'GENERIC_SAVE' | translate:locale.language}} </button>
  <button type="button" class="btn btn-default" (click)="closeBSF()">{{'CANCEL' | translate:locale.language}}</button>
</div>
</div>
